// PastDuePayoffBreakdownCard.jsx
import React from "react";
import useCurrentAccountStore from "./AccountStore";
import shallow from "zustand/shallow";
import dayjs from "dayjs";
import { getPayoffMethodLabels } from "./accountLabelUtils";

export default function PastDueBreakdownCard(props) {
	const money = (n) =>
		new Intl.NumberFormat(undefined, {
			style: "currency",
			currency: "USD",
		}).format(Number(n || 0));
	const acctObj = useCurrentAccountStore((state) => state, shallow);
	const labels = getPayoffMethodLabels(acctObj.account?.payoffMethod);
	const isLease = acctObj.account?.payoffMethod === 4;
	const isRTO = acctObj.account?.payoffMethod === 5;

	const dailyInt = (isLease || isRTO)
		? 0
		: Math.round(
				acctObj.account.dailyIntRate * acctObj.account.principleRemaining * 10000
		  ) / 10000;

	const accruedInterest = (isLease || isRTO)
		? 0
		: Math.round(
				acctObj.account.principleRemaining *
					acctObj.account.dailyIntRate *
					dayjs().diff(acctObj.account.lastScheduledPmtDate, "day") *
					100
		  ) / 100;
	const intDue =
		acctObj.account.interestDue - accruedInterest > 0
			? acctObj.account.interestDue - accruedInterest
			: 0;

	return (
		<div className="card p-3">
			<h5>Calculation Walkthrough</h5>

			<div className="row g-3">
				{/* Scheduled Breakdown */}
				<table className="table table-lg mb-0">
					<tbody>
						<td>
							<tr style={{ fontWeight: "bold" }}>
								{labels.principleRemaining} ={" "}
								{money(acctObj.account.principleRemaining)}
							</tr>
							{!isLease && !isRTO && <tr>Daily Interest ={money(dailyInt)}</tr>}
							<tr>
								Last Scheduled Date =
								{dayjs(acctObj.account.lastScheduledPmtDate).format(
									"MM/DD/YYYY"
								)}
							</tr>
							<tr>Today's Date = ({dayjs().format("MM/DD/YYYY")})</tr>
							<tr>
								Days = (
								{dayjs().diff(acctObj.account.lastScheduledPmtDate, "day")})
							</tr>
							{!isLease && !isRTO && (
								<tr style={{ fontWeight: "bold" }}>
									Accrued Interest ={money(accruedInterest)}
								</tr>
							)}
							{!isRTO && <tr>{labels.interestDue} = {money(intDue)}</tr>}
							<tr>{labels.principalDue} = {money(acctObj.account.principleDue)}</tr>
							{(acctObj.account.isTaxDeferred || acctObj.account.monthlyTax > 0) && (
								<tr style={{ fontWeight: "bold" }}>
									Tax Due = {money(acctObj.account.taxDue)}
								</tr>
							)}
							<tr style={{ fontWeight: "bold" }}>
								{labels.loanDue} ={" "}
								{money(
									(
										acctObj.account.principleDue + (isRTO ? 0 : acctObj.account.interestDue)
									).toFixed(2)
								)}
							</tr>
						</td>
						<td>
							<tr style={{ fontWeight: "bold" }}>
								LateFee Due = {money(acctObj.account.lateFeeDue)}
							</tr>
							<tr style={{ fontWeight: "bold" }}>
								Adjustments Due ={" "}
								{money(
									(
										acctObj.account.debitTotal +
										acctObj.account.creditTotal -
										acctObj.account.debitPaid
									).toFixed(2)
								)}
							</tr>
							<tr style={{ fontWeight: "bold" }}>
								Pickup Due = {money(acctObj.account.pickupPastDue)}
							</tr>
							<tr style={{ fontWeight: "bold", color: "red" }}>
								Past Due Amt = {money(acctObj.account.pastDueAmt)}
							</tr>
						</td>
					</tbody>
				</table>
			</div>
		</div>
	);
}
